import { IUser, IUserInfo } from '../types/User';

export const userAddapter = (item?: IUserInfo) => ({
  _id: item?._id ?? '',
  full_name: item?.full_name ?? '',
  phone_number: item?.phone_number ?? '',
  email: item?.email ?? '',
  date_of_birth: item?.date_of_birth ?? '',
  gender: item?.gender ?? '',
  profile_picture: item?.profile_picture ?? '',
  lastOrderDate: item?.lastOrderDate ?? null,
  deviceUUID: item?.deviceUUID,
});

export const userInfoAdapter = (item?: IUser): IUserInfo => ({
  _id: item?.id.toString() ?? '',
  full_name: item?.title ?? '',
  phone_number: item?.phone_number ?? '',
  email: item?.email ?? '',
  date_of_birth: item?.birthday ?? '',
  gender: item?.gender ?? '1',
  profile_picture: '',
  lastOrderDate: item?.lastOrderDate ?? null,
  // Единственное поле, которое нужно не экрану профиля, а Mindbox: бэкенд
  // знает deviceUUID устройства даже там, где трекер до нас не доехал.
  deviceUUID: item?.deviceUUID ?? item?.device_uuid,
});
